export enum RmsChildrenStrategies {
  MasterContract,
  MasterDate,
}
